import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_SyncEnv = {
    vv1: {
        fetchFromEnv: { method: HttpMethod.POST, path: 'v1/sync-env/fetch-from-env' },
    }
};
//# sourceMappingURL=apis.js.map